import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { setRoleCodeDetails } from "./slice";
import { setRoleCodeDetails as setRoleCodeDetailsGlobal } from "@/features/Global/slice";
import { baseQueryWithDecryption } from "../baseQueryWithEncryption";

export const roleAuthMgmt = createApi({
  reducerPath: "roleAuthMgmt",
  baseQuery: baseQueryWithDecryption(import.meta.env.VITE_COMPANY_API_URL),
  endpoints: (builder) => ({
    // getAllRoleList: builder.query({
    // 	query: ({}) => `/role-mgmt/roles`,
    // }),
    getAllRoleList: builder.query({
      query: () => `/role-mgmt/roles`,
    }),
    getRoleCodeDetails: builder.query({
      query: (roleCode) => `role-mgmt/role-code-details/${roleCode}`,
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          const updatedPermissions =
            data?.data?.decryptedData?.permissionList || [];
          localStorage.setItem(
            "roleDetail",
            JSON.stringify(updatedPermissions)
          );
          dispatch(
            setRoleCodeDetails(data?.data?.decryptedData?.permissionList || [])
          );
          dispatch(
            setRoleCodeDetailsGlobal(
              data?.data?.decryptedData?.permissionList || []
            )
          );
        } catch (error) {
          console.error("Error in onQueryStarted:", error);
          dispatch(setRoleCodeDetails({}));
          dispatch(setRoleCodeDetailsGlobal({}));
        }
      },
    }),
  }),
});
// Export hooks for usage in function components, which are
// auto-generated based on the defined endpoints
export const { useGetAllRoleListQuery, useGetRoleCodeDetailsQuery } =
  roleAuthMgmt;
